var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.994 14a1 1 0 0 0 .606-1.8A3.978 3.978 0 0 1 14 9V6A5.999 5.999 0 1 0 2.006 6v3c0 1.26-.594 2.447-1.605 3.2A1 1 0 0 0 1 14h4.998a2 2 0 1 0 3.998 0h4.998Zm-2.828-7.995v3c0 1.057.29 2.095.835 3H3.005a5.824 5.824 0 0 0 .833-3v-3a4.168 4.168 0 0 1 8.329 0Z"
  })));
};
export default SvgBell;